const formatImgEnum = ['png', 'jpg', 'jpeg', 'svg']

export { formatImgEnum }
